import { render, staticRenderFns } from "./NavChannelsLayer.vue?vue&type=template&id=00b45f22&"
import script from "./NavChannelsLayer.vue?vue&type=script&lang=ts&"
export * from "./NavChannelsLayer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports